document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('toggle-edito-btn');
  const short = document.getElementById('content-short');
  const full = document.getElementById('content-full');

if (btn) {
    btn.addEventListener('click', function() {
      const expanded = full.style.display === 'block';

      if (expanded) {
        full.style.display = 'none';
        short.style.display = 'block';
        btn.textContent = 'Lire la suite';
      } else {
        short.style.display = 'none';
        full.style.display = 'block';
        btn.textContent = 'Lire moins';
      }
    });
  }
});
